var React = require('react');

function WhiteWave (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1280 122H0V30.7568C127.212 2.85031 320.88 -13.2054 603.135 14.7029C626.152 16.9788 648.855 19.2778 671.288 21.5495C886.074 43.2999 1076.1 62.5424 1280 34.9314V122Z","fill":"white"}));
}

WhiteWave.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 1280 122","fill":"none"};

module.exports = WhiteWave;

WhiteWave.default = WhiteWave;
